import React from "react";
import { AnalyticsPage, AnalyticsCard, StatPill } from "./analyticsShared";

export default function EmployerAnalytics() {
    return (
        <AnalyticsPage
            endpoint="/admin/analytics/employer"
            testId="admin-analytics-employer"
            overline="Analytics"
            title="Employer Activity"
            render={(d) => (
                <>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
                        <StatPill label="Avg top-match score" value={d.avg_top_match_score} testId="ea-avg" />
                        <StatPill label="Briefs scored" value={d.matches_scored} tone="sky" testId="ea-count" />
                        <StatPill label="Requests consented" value={d.passport_funnel.consented} tone="emerald" sub={`of ${d.passport_funnel.requested} total`} testId="ea-consented" />
                        <StatPill label="Requests pending" value={d.passport_funnel.pending} tone="amber" sub="awaiting talent response" testId="ea-pending" />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <AnalyticsCard
                            title="Top employers by brief volume"
                            rows={d.top_employers.map((r) => ({ label: r.company, count: r.briefs, ready: r.ready }))}
                            labelKey="label"
                            tone="sky"
                            testId="ea-top-employers"
                        />
                        <AnalyticsCard
                            title="Match score distribution"
                            subtitle="Best match per ready brief"
                            rows={d.match_score_distribution}
                            labelKey="bucket"
                            tone="violet"
                            testId="ea-match-dist"
                        />
                    </div>
                </>
            )}
        />
    );
}
